<template>
    <div class="sensor">
        <div class="sensor__actual">
            <font-awesome-icon
                    class="fa-spin sensor__actual__value"
                    v-if="typeof measurements[0] === 'undefined'"
                    :icon="['fas', 'spinner']"
                    style="height: 68px; margin: 0 auto;"
            />
            <div v-if="measurements[0]">
                <div class="sensor__actual__value">
                    {{ Math.round(measurements[0].value * 10) / 10 }}℃
                </div>
                <div class="sensor__actual__date">{{ minAgo }}</div>
            </div>
        </div>
        <div class="sensor__historical" v-if="chart">
            <font-awesome-icon
                    class="fa-spin"
                    v-if="!measurements[0]"
                    :icon="['fas', 'spinner']"
                    style="font-size: 4rem; margin-top: 50px"
            />
            <GChart
                    v-if="measurements[0]"
                    type="LineChart"
                    :data="chartData"
                    :options="chartOptions"
            />
        </div>
    </div>
</template>

<script>
    import SensorsAPIClient from "@/utils/SensorsAPIClient";

    export default {
        name: 'Sensor',
        props: {
            id: null,
            chart: null
        },
        data() {
            return {
                measurements: [],
                actualTimestamp: new Date().getTime(),
                chartData: [
                    ["Time", "Value"],
                ],
                chartOptions: {
                    legend: {position: 'none'}
                }
            }
        },
        methods: {
            fetchData() {
                let saClient = new SensorsAPIClient();
                saClient.getMeasurements(this.id)
                    .then((results) => {
                        this.measurements = results;
                    });
            },
            resetChartData() {
                this.chartData = [
                    ["Time", "Value"],
                ];
            }
        },
        created() {
            this.fetchData();
            setInterval(() => {
                this.actualTimestamp = new Date().getTime();
            }, 1000 * 10);
            setInterval(() => {
                this.fetchData();
            }, 1000 * 30);
        },
        computed: {
            minAgo() {
                let unit = "min";
                let result = ((this.actualTimestamp - this.measurements[0].timestamp * 1000) / 1000 / 60);
                if (result < 1) {
                    return "przed chwilą";
                } else if (result > 60 * 24 - 1) {
                    unit = 'dni';
                    result /= 60 * 24;
                } else if (result > 60 - 1) {
                    unit = 'godz.';
                    result /= 60;
                }
                return Math.round(result) + unit + " temu";
            }
        },
        watch: {
            measurements() {
                this.resetChartData();
                for (let i = this.measurements.length - 1; i >= 0; i--) {
                    let measure = this.measurements[i];
                    let time = new Date(measure.timestamp * 1000);
                    let stringTime = time.getHours() + ":" + time.getMinutes();
                    this.chartData.push([stringTime, measure.value]);
                }
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .sensor__actual__value {
        font-size: 2rem;
    }
</style>
